import { render, staticRenderFns } from "./CostManagementServices.vue?vue&type=template&id=6bccb23c"
import script from "./CostManagementServices.vue?vue&type=script&lang=js"
export * from "./CostManagementServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports